import { useEffect, useState } from 'react';
import { ethers } from 'ethers';

export function useValues() {
  const [chainId, setChainId] = useState<string>('');

  const [balance, setBalance] = useState<string>('');
  const [to, setTo] = useState<string>('');
  const [value, setValue] = useState<string>('');
  const [nonce, setNonce] = useState<string>('');

  const [maxPriorityFeePerGas, setMaxPriorityFeePerGas] = useState<string>('');
  const [maxFeePerGas, setMaxFeePerGas] = useState<string>('');

  return {
    balance,
    setBalance,
    to,
    setTo,
    value,
    setValue,
    nonce,
    setNonce,
    chainId,
    setChainId,
    maxFeePerGas,
    setMaxFeePerGas,
    maxPriorityFeePerGas,
    setMaxPriorityFeePerGas,
  };
}

// setup default gas fee due to fee data.
export function useDefaultGasFee(
  signer: ethers.Signer | null,
  setMaxFeePerGas: (value: string) => void,
  setMaxPriorityFeePerGas: (value: string) => void
) {
  useEffect(() => {
    if (!signer) return;
    signer.getFeeData().then((feeData) => {
      if (feeData.maxFeePerGas)
        setMaxFeePerGas(feeData.maxFeePerGas.toString());
      if (feeData.maxPriorityFeePerGas)
        setMaxPriorityFeePerGas(feeData.maxPriorityFeePerGas.toString());
    });
  }, [signer, setMaxFeePerGas, setMaxPriorityFeePerGas]);
}

// setup default nonce due to transaction count.
export function useDefaultNonce(
  signer: ethers.Signer | null,
  setNonce: (nonce: string) => void
) {
  useEffect(() => {
    if (!signer) return;
    signer.getTransactionCount().then((nonce) => setNonce(nonce.toString()));
  }, [signer, setNonce]);
}

// get balance of current account
export function useBalance(
  signer: ethers.Signer | null,
  setBalance: (nonce: string) => void
) {
  useEffect(() => {
    if (!signer) return;
    signer.getBalance().then((balance) => setBalance(balance.toString()));
  }, [signer, setBalance]);
}
